import {initWebComponent} from "@/helpers/web-component-helper";
import {
    activateUserSessionByID,
    getUserSessionByID,
    removeUserSession,
    updateSession
} from "@/helpers/user-session-helper";
import {getBySelector} from "@/helpers/element-helper.js";

export class BookmarkUserSessionAddButtonComponent extends HTMLElement {
    constructor(){
        super();

        const id = this.getAttribute('data-id')

        const template = document.createElement('template');

        template.innerHTML = `
            <button class="ml-1 btn btn-sm btn-outline-secondary float-right text-transform-none"  data-bs-toggle="modal" data-bs-target="#mdlSession">
               <span class="fa fa-plus"></span> Bookmark toevoegen
            </button>`

        initWebComponent(this, template)

        this.addEventListener('click', () => {
            getBySelector('#mdlEditUserSessionName').value = ''
        })
    }
}
